import React from 'react';

import { ITestProps } from '../utils/dataTest';

export interface IAccordionWizardProps extends ITestProps {
  /** The active AccordionWizard.Step child component to mark as isActive */
  activeStepIndex?: number;
  children?: any;
  /** Text for all back buttons */
  backButtonText?: string;
  /** Text for all next buttons */
  nextButtonText?: string;
  /** submitButtonText */
  submitButtonText?: string;
  /** Callback function for handling the submit button click event. */
  onSubmit?(): void;
}

export interface IAccordionWizardState {
  /** The active AccordionWizard.Step child component to mark as isActive */
  activeStepIndex: number;
}

export class AccordionWizard extends React.Component<IAccordionWizardProps, IAccordionWizardState> {
  static defaultProps = {
    activeStepIndex: 0,
    onSubmit: () => {}
  };

  constructor(props) {
    super(props);

    const { activeStepIndex } = this.props;

    this.state = {
      activeStepIndex: activeStepIndex !== null ? activeStepIndex : 1
    };
  }

  componentDidUpdate(prevProps) {
    if (this.props.activeStepIndex !== prevProps.activeStepIndex) {
      this.setState({
        activeStepIndex: this.props.activeStepIndex
      });
    }
  }

  decrementStep = () => {
    const activeStepIndex = this.state.activeStepIndex - 1;
    this.setState({ activeStepIndex: activeStepIndex <= 0 ? 0 : activeStepIndex });
  };

  incrementStep = () => {
    const activeStepIndex = this.state.activeStepIndex + 1;
    this.setState({ activeStepIndex });
  };

  render() {
    const { activeStepIndex } = this.state;
    const { children, dataTest, backButtonText, nextButtonText, submitButtonText } = this.props;

    return (
      <ul data-test={dataTest}>
        {React.Children.map(children, (childRef, index) => {
          const child = childRef as any; // ReactElement<any>

          return React.cloneElement(child, {
            index: index,
            isActive: activeStepIndex === index,
            isFirstStep: index === 0,
            isLastStep: index + 1 === React.Children.count(children),
            isComplete: index < activeStepIndex,
            dataTest: `${dataTest}-step-${index}`,
            backButtonText,
            nextButtonText,
            submitButtonText,
            onBack: () => (child.props.onBack ? child.props.onBack() : this.decrementStep()),
            onNext: () => (child.props.onNext ? child.props.onNext() : this.incrementStep()),
            onSubmit: this.props.onSubmit
          });
        })}
      </ul>
    );
  }
}
